import _ from "lodash";
import api from "@/api";

export default {
  namespaced: true,
  state: {
    list: [],
    meta: {},
    promo_code: {
      name: ""
    },
    show_suspended: false,
    term: "",
    filters: {},
    filter_applied: false
  },
  getters: {},
  mutations: {
    SET_SEARCH_TEXT: (state, payload) => {
      state.term = payload;
    },
    SET_FILTERS: (state, payload) => {
      state.filters = payload;
    },
    SET_PROMO_CODES_DATA: (state, payload) => {
      state.list = payload.data;
      state.meta = payload.meta;
    }
  },
  actions: {
    getData: async ({ state, commit, getters }, page_number) => {
      // this could be fix in BE to just set show_archived as bool
      let show_archived = state.show_suspended ? 1 : "";

      const data = await api.get("/promo-codes", {
        params: {
          page: page_number,
          per_page: 20,
          show_archived: show_archived,
          term: state.term
        }
      });

      state.filter_applied = getters.is_filter_active;

      const result = _.get(data, "data.result", []);

      commit("SET_PROMO_CODES_DATA", result);
    }
  },
  modules: {}
};
